export const rootSelector = (state: Record<string, any>): Record<string, any> => state || {}
